import { useQuery } from 'react-query';
import { getJobOffers } from '../api/getJobOffers';
import { JobOffersSuccessResponse } from '../api/getJobOffers.types';

export const useGetJobOffers = () =>
    useQuery<JobOffersSuccessResponse, Error>(['jobOffers'], getJobOffers);
